import { createWebHistory, createRouter } from "vue-router";
import store from "../store";
import HTTP from "../plugins/backendAPI";
import { logout } from "../helpers/logoutHandler";
import FeedbackForm from "@/views/MobileApp/FeedbackForm";
import MobileMain from "../views/MobileApp/MobileMain.vue";
import AdminMain from "../views/AdminPortal/AdminMain.vue";
import AuthCallback from "../views/AdminPortal/Auth/AuthCallback.vue";
import FormSentSuccess from "../views/MobileApp/FormSentSuccess.vue";
import QrCodeEditSuccess from "../views/MobileApp/QrCodeEditSuccess.vue";
import QrCodeEdit from "../views/MobileApp/QrCodeEdit.vue";
import ContactRequestForm from "../views/MobileApp/ContactRequestForm.vue";
import MobileSignIn from "../views/MobileApp/MobileSignIn.vue";
import FaultReportForm from "../views/MobileApp/FaultReportForm.vue";
import FormSelect from "../views/MobileApp/FormSelect.vue";
import IssueManagementPage from "../views/AdminPortal/IssuePage.vue";
import QrCodeManagementPage from "../views/AdminPortal/QrCodePage.vue";
import QrCategoryManagementPage from "../views/AdminPortal/QrCategoryPage.vue";
import FormManagementPage from "../views/AdminPortal/FormPage.vue";
import LocationManagementPage from "../views/AdminPortal/LocationPage.vue";
import InventoryManagementPage from "../views/AdminPortal/InventoryPage.vue";
import StatisticsDashboard from "../views/AdminPortal/StatisticsDashboard.vue";
import UserManagementPage from "../views/AdminPortal/UserPage.vue";
import WorkspaceManagementPage from "../views/AdminPortal/WorkspacePage.vue";
import SystemInventoryTypeManagementPage from "../views/AdminPortal/SystemInventoryTypePage.vue";
import OrganizationManagementPage from "../views/AdminPortal/OrganizationPage.vue";
import SsoWelcomePage from "../views/AdminPortal/SsoWelcomePage.vue";
import MapPage from "../views/MapPage.vue";
import AdminSignInPage from "../views/AdminPortal/Auth/AdminSignInPage.vue";
import SsoAccountRegistrationPage from "../views/AdminPortal/Auth/SsoAccountRegistrationPage.vue";
import AccountLinkingPage from "../views/AdminPortal/Auth/AccountLinkingPage.vue";
import PasswordRecoveryPage from "../views/AdminPortal/Auth/PasswordRecoveryPage.vue";
import ChangePasswordPage from "../views/AdminPortal/Auth/ChangePasswordPage.vue";
import QrImagePage from "../views/QrImagePage.vue";
import ImageViewer from "../views/ImageViewer.vue";

const routes = [
  {
    path: "/",
    redirect: "/issues",
  },
  {
    path: "/imageViewer/bilder/:imageId",
    name: "ImageViewer",
    component: ImageViewer,
    props: true,
  },
  {
    path: "/",
    component: AdminMain,
    meta: { requiresAuth: true },
    children: [
      {
        path: "issues",
        name: "Issue",
        component: IssueManagementPage,
        props: true,
      },
      {
        path: "qr-codes",
        name: "QrCode",
        component: QrCodeManagementPage,
        props: true,
      },
      {
        path: "qr-categories",
        name: "QrCategory",
        component: QrCategoryManagementPage,
      },
      {
        path: "forms",
        name: "Form",
        component: FormManagementPage,
        beforeEnter: () => {
          if (!store.getters.useForms || store.getters.useForms === undefined) {
            store.dispatch("showError", "Your organization has disabled forms. <br><br> Redirecting...");
            return { name: "Issue" };
          }
        },
      },
      {
        path: "locations",
        name: "Location",
        component: LocationManagementPage,
      },
      {
        path: "inventories",
        name: "Inventory",
        component: InventoryManagementPage,
      },
      {
        path: "statistics",
        name: "Statistics",
        component: StatisticsDashboard,
      },
      {
        path: "users",
        name: "User",
        component: UserManagementPage,
        meta: { requiresAdmin: true },
      },
      {
        path: "workspaces",
        name: "Workspace",
        component: WorkspaceManagementPage,
        meta: { requiresAdmin: true },
      },
      {
        path: "system-inventory-types",
        name: "SystemInventoryType",
        component: SystemInventoryTypeManagementPage,
        meta: { requiresSuperAdmin: true },
      },
      {
        path: "organizations",
        name: "Organization",
        component: OrganizationManagementPage,
        meta: { requiresSuperAdmin: true },
      },
      {
        path: "/sso/welcome",
        name: "SsoWelcome",
        component: SsoWelcomePage,
        beforeEnter: () => {
          if (store.getters.userAuthProvider === "Local" || !store.getters.userAuthProvider) {
            return { name: "Issue" };
          }
          if (
            store.getters.isadministrator ||
            store.getters.issuperadministrator ||
            store.getters.hasWorkspaceAuthorization
          ) {
            return { name: "Issue" };
          }
        },
      },
    ],
  },
  {
    path: "/m/:qrstring",
    props: true,
    component: MobileMain,
    beforeEnter: async (to, from) => {
      if (store.getters.isQrCodeRegistered === undefined || !from.name) {
        await HTTP.get(
          `/mobil/checkifqrexists/${to.params.qrstring}/${to.params.workspaceid}/${to.params.qrworkspaceid}`
        )
          .then(async (response) => {
            await store.dispatch("saveQrCodeStatus", response.data.isFound);
            await store.dispatch("doesOrganizationUseForms", response.data.useForms);
            if (response.data.isUsePinCode) {
              await store.dispatch("usePinCodeForMobileAuth");
            } else {
              await store.dispatch("dontUsePinCodeForMobileAuth");
            }
          })
          .catch(async (err) => {
            await store.dispatch("showError", err.response.data);
          });
      }
      if (to.name === undefined) {
        return {
          name: "LegacyMobileFormSelect",
          params: { qrstring: to.params.qrstring },
        };
      }
    },
    children: [
      {
        path: "select",
        props: true,
        name: "LegacyMobileFormSelect",
        component: FormSelect,
        beforeEnter: (to) => {
          if (!store.getters.isQrCodeRegistered) {
            return {
              name: "LegacyMobileQrCodeEdit",
              params: { qrstring: to.params.qrstring },
            };
          } else if (store.getters.isusepincodeformobileauth && !store.getters.ismobileauthorized) {
            return {
              name: "LegacyMobileSignIn",
              params: { qrstring: to.params.qrstring },
            };
          }
        },
      },
      {
        path: "login",
        props: true,
        name: "LegacyMobileSignIn",
        component: MobileSignIn,
        beforeEnter: (to) => {
          if (!store.getters.isQrCodeRegistered) {
            if (!store.getters.isauthorized) {
              store.dispatch("showError", "You need to sign-in to access edit mode for this qr-code!");
            }
            return {
              name: "LegacyMobileQrCodeEdit",
              params: { qrstring: to.params.qrstring },
            };
          } else if (
            (store.getters.isusepincodeformobileauth && store.getters.ismobileauthorized) ||
            !store.getters.isusepincodeformobileauth
          ) {
            return {
              name: "LegacyMobileFormSelect",
              params: { qrstring: to.params.qrstring },
            };
          }
        },
      },
      {
        path: "report/:qrdetailid",
        props: true,
        name: "LegacyMobileFaultReportForm",
        component: FaultReportForm,
        beforeEnter: (to) => {
          if (!store.getters.isQrCodeRegistered) {
            if (!store.getters.isauthorized) {
              store.dispatch("showError", "You need to sign-in to access edit mode for this qr-code!");
            }
            return {
              name: "LegacyMobileQrCodeEdit",
              params: { qrstring: to.params.qrstring },
            };
          } else if (store.getters.isusepincodeformobileauth && !store.getters.ismobileauthorized) {
            return {
              name: "LegacyMobileSignIn",
              params: { qrstring: to.params.qrstring },
            };
          }
        },
      },
      {
        path: "form/feedback",
        props: true,
        name: "LegacyMobileFeedbackForm",
        component: FeedbackForm,
        beforeEnter: (to) => {
          if (!store.getters.useForms) {
            store.dispatch("showError", "The qr code does not support the usage of forms.");
            return {
              name: "LegacyMobileFormSelect",
              params: { qrstring: to.params.qrstring },
            };
          } else if (!store.getters.isQrCodeRegistered) {
            if (!store.getters.isauthorized) {
              store.dispatch("showError", "You need to sign-in to access edit mode for this qr-code!");
            }
            return {
              name: "LegacyMobileQrCodeEdit",
              params: { qrstring: to.params.qrstring },
            };
          } else if (store.getters.isusepincodeformobileauth && !store.getters.ismobileauthorized) {
            return {
              name: "LegacyMobileSignIn",
              params: { qrstring: to.params.qrstring },
            };
          }
        },
      },
      {
        path: "form/contact-request",
        props: true,
        name: "LegacyMobileContactRequestForm",
        component: ContactRequestForm,
        beforeEnter: (to) => {
          if (!store.getters.useForms) {
            store.dispatch("showError", "The qr code does not support the usage of forms.");
            return {
              name: "LegacyMobileFormSelect",
              params: { qrstring: to.params.qrstring },
            };
          } else if (!store.getters.isQrCodeRegistered) {
            if (!store.getters.isauthorized) {
              store.dispatch("showError", "You need to sign-in to access edit mode for this qr-code!");
            }
            return {
              name: "LegacyMobileQrCodeEdit",
              params: { qrstring: to.params.qrstring },
            };
          } else if (store.getters.isusepincodeformobileauth && !store.getters.ismobileauthorized) {
            return {
              name: "LegacyMobileSignIn",
              params: { qrstring: to.params.qrstring },
            };
          }
        },
      },
      {
        path: "edit",
        name: "LegacyMobileQrCodeEdit",
        props: true,
        component: QrCodeEdit,
        meta: { requiresAuth: true },
      },
      {
        path: "report/success",
        name: "LegacyMobileFaultReportSentSuccess",
        props: true,
        component: FormSentSuccess,
      },
      {
        path: "form/success",
        name: "LegacyMobileFormSentSuccess",
        props: true,
        component: FormSentSuccess,
      },
      {
        path: "edit/success",
        name: "LegacyMobileEditSuccess",
        props: true,
        component: QrCodeEditSuccess,
      },
    ],
  },
  {
    path: "/m/:workspaceid/:qrworkspaceid",
    props: true,
    component: MobileMain,
    beforeEnter: async (to, from) => {
      if (store.getters.isQrCodeRegistered === undefined || !from.name) {
        await HTTP.get(
          `/mobil/checkifqrexists/${to.params.qrstring}/${to.params.workspaceid}/${to.params.qrworkspaceid}`
        )
          .then(async (response) => {
            await store.dispatch("saveQrCodeStatus", response.data.isFound);
            await store.dispatch("doesOrganizationUseForms", response.data.useForms);
            if (response.data.isUsePinCode) {
              await store.dispatch("usePinCodeForMobileAuth");
            } else {
              await store.dispatch("dontUsePinCodeForMobileAuth");
            }
          })
          .catch(async (err) => {
            await store.dispatch("showError", err.response.data);
            await store.dispatch("setRedirectRoute", to.fullPath);
            return {
              name: "AdminSignIn",
            };
          });
      }
      if (to.name === undefined) {
        return {
          name: "MobileFormSelect",
          params: { workspaceid: to.params.workspaceid, qrworkspaceid: to.params.qrworkspaceid },
        };
      }
    },
    children: [
      {
        path: "select",
        props: true,
        name: "MobileFormSelect",
        component: FormSelect,
        beforeEnter: (to) => {
          if (!store.getters.isQrCodeRegistered) {
            if (!store.getters.isauthorized) {
              store.dispatch("showError", "You need to sign-in to access edit mode for this qr-code!");
            }
            return {
              name: "MobileQrCodeEdit",
              params: { workspaceid: to.params.workspaceid, qrworkspaceid: to.params.qrworkspaceid },
            };
          } else if (store.getters.isusepincodeformobileauth && !store.getters.ismobileauthorized) {
            return {
              name: "MobileSignIn",
              params: { workspaceid: to.params.workspaceid, qrworkspaceid: to.params.qrworkspaceid },
            };
          }
        },
      },
      {
        path: "sign-in",
        props: true,
        name: "MobileSignIn",
        component: MobileSignIn,
        beforeEnter: (to) => {
          if (!store.getters.isQrCodeRegistered) {
            if (!store.getters.isauthorized) {
              store.dispatch("showError", "You need to sign-in to access edit mode for this qr-code!");
            }
            return {
              name: "MobileQrCodeEdit",
              params: { workspaceid: to.params.workspaceid, qrworkspaceid: to.params.qrworkspaceid },
            };
          } else if (
            (store.getters.isusepincodeformobileauth && store.getters.ismobileauthorized) ||
            !store.getters.isusepincodeformobileauth
          ) {
            return {
              name: "MobileFormSelect",
              params: { workspaceid: to.params.workspaceid, qrworkspaceid: to.params.qrworkspaceid },
            };
          }
        },
      },
      {
        path: "report/:qrdetailid",
        props: true,
        name: "MobileFaultReportForm",
        component: FaultReportForm,
        beforeEnter: (to) => {
          if (!store.getters.isQrCodeRegistered) {
            if (!store.getters.isauthorized) {
              store.dispatch("showError", "You need to sign-in to access edit mode for this qr-code!");
            }
            return {
              name: "MobileQrCodeEdit",
              params: { workspaceid: to.params.workspaceid, qrworkspaceid: to.params.qrworkspaceid },
            };
          } else if (store.getters.isusepincodeformobileauth && !store.getters.ismobileauthorized) {
            return {
              name: "MobileSignIn",
              params: { workspaceid: to.params.workspaceid, qrworkspaceid: to.params.qrworkspaceid },
            };
          }
        },
      },
      {
        path: "form/feedback",
        props: true,
        name: "MobileFeedbackForm",
        component: FeedbackForm,
        beforeEnter: (to) => {
          if (!store.getters.useForms) {
            store.dispatch("showError", "The qr code does not support the usage of forms.");
            return {
              name: "MobileFormSelect",
              params: { workspaceid: to.params.workspaceid, qrworkspaceid: to.params.qrworkspaceid },
            };
          } else if (!store.getters.isQrCodeRegistered) {
            if (!store.getters.isauthorized) {
              store.dispatch("showError", "You need to sign-in to access edit mode for this qr-code!");
            }
            return {
              name: "MobileQrCodeEdit",
              params: { workspaceid: to.params.workspaceid, qrworkspaceid: to.params.qrworkspaceid },
            };
          } else if (store.getters.isusepincodeformobileauth && !store.getters.ismobileauthorized) {
            return {
              name: "MobileSignIn",
              params: { workspaceid: to.params.workspaceid, qrworkspaceid: to.params.qrworkspaceid },
            };
          }
        },
      },
      {
        path: "form/contact-request",
        props: true,
        name: "MobileContactRequestForm",
        component: ContactRequestForm,
        beforeEnter: (to) => {
          if (!store.getters.useForms) {
            store.dispatch("showError", "The qr code does not support the usage of forms.");
            return {
              name: "MobileFormSelect",
              params: { workspaceid: to.params.workspaceid, qrworkspaceid: to.params.qrworkspaceid },
            };
          } else if (!store.getters.isQrCodeRegistered) {
            if (!store.getters.isauthorized) {
              store.dispatch("showError", "You need to sign-in to access edit mode for this qr-code!");
            }
            return {
              name: "MobileQrCodeEdit",
              params: { workspaceid: to.params.workspaceid, qrworkspaceid: to.params.qrworkspaceid },
            };
          } else if (store.getters.isusepincodeformobileauth && !store.getters.ismobileauthorized) {
            return {
              name: "MobileSignIn",
              params: { workspaceid: to.params.workspaceid, qrworkspaceid: to.params.qrworkspaceid },
            };
          }
        },
      },
      {
        path: "edit",
        name: "MobileQrCodeEdit",
        props: true,
        component: QrCodeEdit,
        meta: { requiresAuth: true },
      },
      {
        path: "report/success",
        name: "MobileFaultReportSentSuccess",
        props: true,
        component: FormSentSuccess,
      },
      {
        path: "form/success",
        name: "MobileFormSentSuccess",
        props: true,
        component: FormSentSuccess,
      },
      {
        path: "edit/success",
        name: "MobileQrCodeEditSuccess",
        props: true,
        component: QrCodeEditSuccess,
      },
    ],
  },
  {
    path: "/display-map/:qrCodeId",
    name: "MapPage",
    props: true,
    component: MapPage,
    meta: { requiresAuth: false },
  },
  {
    path: "/sign-in",
    name: "AdminSignIn",
    props: true,
    component: AdminSignInPage,
    beforeEnter: async () => {
      if (await checkAuth("auth")) {
        return {
          name: "Issue",
        };
      }
    },
  },
  {
    path: "/register",
    name: "SsoAccountRegistration",
    props: true,
    component: SsoAccountRegistrationPage,
    beforeEnter: async (to) => {
      if (await checkAuth("auth")) {
        return {
          name: "Issue",
        };
      }
      if (!to.query["entra-tenant-id"] || !to.query["organization-id"]) {
        await logout();
      }
    },
  },
  {
    path: "/link-accounts",
    name: "LinkAccounts",
    props: true,
    component: AccountLinkingPage,
    beforeEnter: async (to, from) => {
      if (await checkAuth("auth")) {
        return {
          name: "Issue",
        };
      }
      if (
        to.query["entra-tenant-id"] === undefined ||
        to.query["organization-id"] === undefined ||
        to.query["auth-method"] === undefined ||
        to.query["email"] === undefined
      ) {
        await logout();
      }
      if (from.name !== "AuthCallback") {
        if (to.query["auth-method"] === "SAML") {
          return {
            name: "SsoAccountRegistration",
            query: {
              "auth-method": "SAML",
              "entra-tenant-id": to.query["entra-tenant-id"],
              "organization-id": to.query["organization-id"],
              "auto-accept": true,
            },
          };
        } else if (to.query["auth-method"] === "OIDC") {
          return {
            name: "SsoAccountRegistration",
            query: {
              "auth-method": "OIDC",
              "entra-tenant-id": to.query["entra-tenant-id"],
              "organization-id": to.query["organization-id"],
              "auto-accept": true,
            },
          };
        } else {
          store.dispatch(
            "showError",
            `Account linking failed: Invalid auth method <br><br>Contact your admin if this issue persists.`
          );
          await logout();
        }
      }
    },
  },
  {
    path: "/auth/callback",
    name: "AuthCallback",
    props: true,
    component: AuthCallback,
  },
  {
    path: "/recover-password",
    name: "RecoverPassword",
    component: PasswordRecoveryPage,
  },
  {
    path: "/change-password/:guid",
    name: "ChangePassword",
    props: true,
    component: ChangePasswordPage,
  },
  {
    path: "/qr-image/:qrstring",
    name: "QrImageLegacy",
    props: true,
    meta: { requiresAuth: true },
    component: QrImagePage,
  },
  {
    path: "/qr-image/:workspaceid/:qrworkspaceid",
    name: "QrImage",
    props: true,
    meta: { requiresAuth: true },
    component: QrImagePage,
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach(async (to) => {
  if (!!to.meta.requiresAuth && !store.getters.userAuthProvider) {
    HTTP.defaults.headers.common["Authorization"] = "Bearer " + store.getters.bearertoken;
    await HTTP.get("/users/get/logged-in-user")
      .then((response) => {
        store.dispatch("saveAuthorization", {
          username: response.data.email,
          isauthorized: true,
          bearertoken: HTTP.defaults.headers.common["Authorization"].substring("bearer ".length),
          isadministrator: response.data.isAdministrator,
          issuperadministrator: response.data.isSuperAdministrator,
          isOwner: response.data.role === 1 ? true : false,
          hasWorkspaceAuthorization: response.data.hasWorkspaceAuthorization,
          userAuthProvider: response.data.authProvider,
        });
      })
      .catch(async () => {
        if (store.getters.isauthorized) {
          await logout();
        }
      });
  }
  if (
    !!to.meta.requiresAuth &&
    to.name !== "SsoWelcome" &&
    store.getters.userAuthProvider !== "Local" &&
    store.getters.userAuthProvider &&
    !store.getters.isadministrator &&
    !store.getters.issuperadministrator &&
    !store.getters.hasWorkspaceAuthorization
  ) {
    return { name: "SsoWelcome" };
  }

  if (!!to.meta.requiresAuth && !(await checkAuth("auth"))) {
    store.dispatch("setRedirectRoute", to.fullPath);
    await logout();
  }
  if (!!to.meta.requiresAdmin && !(await checkAuth("admin"))) {
    await store.dispatch("showError", "You're account is not authorized for this page. <br><br> Redirecting...");
    return { name: "Issue" };
  }
  if (!!to.meta.requiresSuperAdmin && !(await checkAuth("super-admin"))) {
    await store.dispatch("showError", "You're account is not authorized for this page. <br><br> Redirecting...");
    return { name: "Issue" };
  }
});

async function checkAuth(authLevel) {
  if (HTTP.defaults.headers.common["Authorization"] === undefined) {
    HTTP.defaults.headers.common["Authorization"] = `Bearer ${store.getters.bearertoken}`;
  }
  if (store.getters.isauthorized === undefined) {
    return false;
  } else if (authLevel === "admin" || authLevel === "super-admin") {
    let userAuthorized = false;
    await HTTP.get("/users/auth/roles")
      .then((response) => {
        if (authLevel === "admin" && !response.data.isAdmin && !response.data.isSuperAdmin) {
          userAuthorized = false;
        } else if (authLevel === "super-admin" && !response.data.isSuperAdmin) {
          userAuthorized = false;
        } else {
          userAuthorized = true;
        }
      })
      .catch(() => {
        userAuthorized = false;
      });
    return userAuthorized;
  } else if (authLevel === "auth" && store.getters.isauthorized) {
    return true;
  } else {
    return false;
  }
}

export default router;
